import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, of } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';

@Pipe({
  name: 'inDollars',
})
export class InDollarsPipe extends CurrencyPipe implements PipeTransform {
  transform(value) {
    let result;

    if (value == null) { return null; }

    let arr = value.toString().split('.');

    if (arr.length > 1) {
      result = super.transform(value, 'AUD', 'symbol-narrow', '1.2-2');
    } else {
      result = super.transform(value, 'AUD', 'symbol-narrow', '1.0-2');
    }

    return result;
  }
}